import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { db } from '../serices/firebase';
import { collection, query, where, onSnapshot } from 'firebase/firestore';
import { Loader2, ArrowLeft, Trophy } from 'lucide-react';
import { motion } from 'framer-motion';

const CategoryDetails = () => {
  const { id } = useParams(); // id is the Award Name from the URL
  const [nominees, setNominees] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchNominees = async () => {
      setLoading(true);
      try {
        // Query nominations where 'category' field matches the Award Name (id)
        const q = query(
          collection(db, "nominations"), 
          where("category", "==", id), 
          where("status", "==", "approved")
        );

        const unsubscribe = onSnapshot(q, (querySnapshot) => {
          const data = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
          setNominees(data);
          setLoading(false);
        });

        return () => unsubscribe();
      } catch (error) {
        console.error("Error fetching nominees:", error);
        setLoading(false);
      }
    };
    fetchNominees();
  }, [id]);

  if (loading) return <div className="min-h-screen bg-black flex items-center justify-center"><Loader2 className="animate-spin text-[#D4AF37]" size={48} /></div>;

  return (
    <div className="min-h-screen bg-black text-white pt-10 pb-20 px-6 relative overflow-hidden">
      <div className="max-w-7xl mx-auto relative z-10">
        
        <Link to="/categories" className="inline-flex items-center gap-2 text-[10px] font-black uppercase tracking-widest text-white/40 hover:text-[#D4AF37] mb-12 transition-all">
          <ArrowLeft size={14} /> Back to Portal
        </Link>

        <header className="mb-20">
          <p className="text-[#D4AF37] text-[10px] font-black uppercase tracking-[0.5em] mb-4">Official Nominees</p>
          <h1 className="text-5xl md:text-7xl font-black uppercase italic tracking-tighter text-white leading-none">
            {id} <br /> <span className="text-[#D4AF37]">CONTENDERS</span>
          </h1>
        </header>

        {nominees.length === 0 ? (
          <div className="text-center py-20 border border-white/5 bg-white/[0.01] rounded-3xl">
             <p className="text-white/40 uppercase tracking-widest font-bold">No nominees approved in this category yet.</p>
          </div>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            {nominees.map((person, i) => (
              <motion.div key={person.id} initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.1 }}>
                <Link to={`/vote/${person.slug}`}>
                  <div className="relative aspect-[3/4] rounded-3xl overflow-hidden border border-white/10 group hover:border-[#D4AF37] transition-all duration-500 shadow-2xl">
                    <img src={person.imageUrl} className="w-full h-full object-cover grayscale group-hover:grayscale-0 group-hover:scale-110 transition-all duration-700" alt={person.name} />
                    <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-transparent opacity-80" />
                    <div className="absolute bottom-6 left-6 right-6">
                      <h3 className="text-xl font-black uppercase italic text-white tracking-tighter group-hover:text-[#D4AF37] transition-colors">
                        {person.name}
                      </h3>
                    </div>
                  </div>
                </Link>
              </motion.div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default CategoryDetails;